import {Livewire} from "../../vendor/livewire/livewire/dist/livewire.esm";

import "./alpine.js";
import "./axios.js";
import "./script.js";

import "./form.js";
import "./media.js";
import "./size.js";

import "./toaster.js";

import "./splide.js";
/*import "./fslightbox.js";*/

import "./countdown.js";

import "./revolut.js";

import './jquery.js';
import './ckeditor.js';
import './signature-pad.js';

import "./tracking/matomo.js";
import "./tracking/posthog.js";

import "./serviceworker.js";

Livewire.start();
